<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">审核平台</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="160px">
        <el-form-item label="平台号:">
          <span>{{ basicInfo.code }}</span>
        </el-form-item>
        <el-form-item label="业务:">
          <span style="display:inline-block;width:180px">{{ basicInfo.salesman ? basicInfo.salesman.fullName : '' }}</span>
          <el-button style="margin-left:20px" v-permission="'crm:admin:store:specialInfo'" round @click="$router.push({ path: './changesalesman', query: { id: $route.query.id } })">变更业务</el-button>
        </el-form-item>
        <el-form-item label="平台名称:"> {{ basicInfo.name }} </el-form-item>
        <el-form-item label="公司名称:"> {{ basicInfo.companyName }} </el-form-item>
        <el-form-item label="手机号:"> {{ basicInfo.phone }} </el-form-item>
        <el-form-item label="公司地区:" prop="address" v-if="$route.query.auditStatus !== 'HANDLE'">
          <el-select v-model="selectAddress.sheng" value-key="code" @change="getAllshi" clearable>
            <el-option v-for="(option, index) in address.sheng" :key="'provinces' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.shi" value-key="id" @change="getAllQu" clearable>
            <el-option v-for="(option, index) in address.shi" :key="'city' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.qu" value-key="id" clearable>
            <el-option v-for="(option, index) in address.qu" :key="'region' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司地区:" prop="address" v-if="$route.query.auditStatus === 'HANDLE'">
          <span>{{ basicInfo.address ? basicInfo.address.province : '' }}{{ basicInfo.address ? basicInfo.address.city : '' }}{{ basicInfo.address ? basicInfo.address.county : '' }}</span>
        </el-form-item>
        <el-form-item label="公司详细地址:" prop="address">
          <el-input v-model="basicInfo.address.fullAddress" v-if="$route.query.auditStatus !== 'HANDLE'" style="width: 400px" maxlength="80" :autosize="{ minRows: 2, maxRows: 4 }">
          </el-input>
          <span v-if="$route.query.auditStatus === 'HANDLE'">{{ basicInfo.address.fullAddress }}</span>
        </el-form-item>
        <el-form-item label="营业执照:">
          <el-image style="max-width:200px" v-if="basicInfo.licenseUrl !== undefined && basicInfo.licenseUrl !== ''" class="yingye" :src="basicInfo.licenseUrl"
            :preview-src-list="[basicInfo.licenseUrl]"></el-image>
        </el-form-item>
        <!-- <el-form-item label="子管理员订单隔离:" prop="subDataIsolation">
          <el-switch v-model="basicInfo.subDataIsolation" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item> -->
        <el-form-item label="平台类型:" clearable>
          <el-select v-model="basicInfo.storeTypeBean.id" placeholder="请选择" class="customer-select" @change="basicInfo.startups = 0">
            <el-option :label="item.name" :value="item.id" v-for="item in platformType" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否初创平台:" prop="startups" v-if="basicInfo.storeTypeBean.id == 10010">
          <el-switch v-model="basicInfo.startups" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="影像季上传设计版模块:" prop="showProductCenter" v-show="false">
          <el-switch v-model="basicInfo.showProductCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" @change="showProductCenterChange"></el-switch>
        </el-form-item>
        <el-form-item label="产品中心:" prop="productCenter" v-if="basicInfo.showProductCenter">
          <el-switch v-model="basicInfo.productCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item class="noleft-third-title">
          <div class="third-title"><span>发货信息</span></div>
        </el-form-item>
        <el-form-item label="发货目的地:">
          <div> {{ +basicInfo.sendFlag === 0 ? '平台地址' : +basicInfo.sendFlag === 1 ? '终端客户' : '未定义' }} <!-- <el-radio v-model="basicInfo.sendFlag" :label="0">平台地址</el-radio>
            <el-radio v-model="basicInfo.sendFlag" :label="1">终端客户</el-radio> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round style="width: 100px" @click="checkType = false, checkDialog = true" v-preventReClick>审核拒绝</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="checkType = true, checkDialog = true" v-preventReClick>审核通过</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="checkDialog" width="30%">
      <span>{{ checkType ? '是否确认审核通过？' : '是否确认审核拒绝？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="check" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="审核成功" :visible.sync="checkTrueDialog" width="30%">
      <p style="  text-align: left;
          text-indent: 40px;
          color: #666;
          line-height: 30px;
          font-weight: bold;
          margin-bottom: 20px;"> 审核平台成功，已将账号信息以短信形式发送 </p>
      <el-form ref="form" :model="storeMsg" label-width="150px">
        <el-form-item label="平台号：" style="margin-bottom: 5px;">
          <span>{{ storeMsg.code }}</span>
        </el-form-item>
        <el-form-item label="平台名称：" style="margin-bottom: 5px;">
          <span>{{ storeMsg.name }}</span>
        </el-form-item>
        <el-form-item label="账号：" style="margin-bottom: 5px;">
          <span>{{ storeMsg.userName }}</span>
        </el-form-item>
        <el-form-item label="密码：" v-show="storeMsg.password !== undefined" style="margin-bottom: 5px;">
          <span>{{ storeMsg.password }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$router.go(-1)" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { storeTypeGetStoreTypeList, storeQueryByStoreId, checkStoreCode, storeAuditStore, addressGetCountyByCityId, addressGetCityByProvinceCode, addressGetAllProvince } from '@/api/crm'

export default {
  name: 'check-plateform',
  data () {
    return {
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      selectAddress: {
        sheng: {
          name: ''
        },
        shi: {
          name: ''
        },
        qu: {
          name: ''
        }
      },
      address: {
        sheng: [],
        shi: [],
        qu: []
      },
      basicInfo: {
        address: {
          // fullAddress: ''
          city: '',
          cityId: '',
          county: '',
          countyId: '',
          fullAddress: '',
          id: '',
          province: '',
          provinceCode: ''
        },
        storeTypeBean: {
          id: null
        }
      },
      platformType: [],
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  created () {
    let id = this.$route.query.id
    storeTypeGetStoreTypeList().then((res) => {
      this.platformType = res.data.data
    })
    storeQueryByStoreId(id).then((res) => {
      if (res.data.success) {
        let obj = {}
        obj = res.data.data
        obj.phone = this.$msg.filterBridal(res.data.data.phone)
        obj.sendFlag = obj.sendFlag === undefined ? '1' : obj.sendFlag
        if (!obj.address) {
          obj.address = {}
        }
        if (res.data.data.storeTypeBean === undefined) {
          obj.storeTypeBean = {
            id: ''
          }
        }
        this.basicInfo = obj
        if (this.basicInfo.address) {
          this.selectAddress = {
            sheng: {
              code: this.basicInfo.address.provinceCode,
              name: this.basicInfo.address.province
            },
            shi: {
              id: this.basicInfo.address.cityId,
              name: this.basicInfo.address.city
            },
            qu: {
              id: this.basicInfo.address.countyId,
              name: this.basicInfo.address.county
            }
          }
          this.getAllSheng()
          this.getAllshi()
          this.getAllQu()
        }
      } else {
        this.basicInfo.address = {}
      }
    })
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    showProductCenterChange (val) {
      console.log('val', val)
      if (val == 1) {
        this.basicInfo.productCenter = 1
      } else {
        this.basicInfo.productCenter = 0
      }
    },
    getAllQu () {
      if (this.selectAddress.shi === '') {
        this.selectAddress.qu = ''
        return
      }
      if (!this.selectAddress.shi.id) return
      addressGetCountyByCityId(this.selectAddress.shi.id).then(res => {
        if (res.data.success) {
          this.address.qu = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.qu.id }).length === 0) {
            this.selectAddress.qu = res.data.data[0]
          }
        }
      })
    },
    getAllshi () {
      if (this.selectAddress.sheng === '') {
        this.selectAddress.shi = ''
        this.selectAddress.qu = ''
        return
      }
      if (!this.selectAddress.sheng.code) return
      addressGetCityByProvinceCode(this.selectAddress.sheng.code).then(res => {
        if (res.data.success) {
          this.address.shi = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.shi.id }).length === 0) {
            this.selectAddress.shi = res.data.data[0]
            this.selectAddress.qu = ''
            this.getAllQu()
          }
        }
      })
    },
    getAllSheng () {
      addressGetAllProvince().then(res => {
        if (res.data.success) {
          this.address.sheng = res.data.data
        }
      })
    },
    check () {
      if (this.checkType && !this.basicInfo.salesman) {
        this.$message.error('请先绑定业务')
        return
      }
      if (this.checkType && !this.basicInfo.storeTypeBean.id) {
        this.$message.error('平台类型未选择')
        return
      }
      let addressVo = {
        city: this.selectAddress.shi.name,
        cityId: this.selectAddress.shi.id,
        county: this.selectAddress.qu.name,
        countyId: this.selectAddress.qu.id,
        fullAddress: this.basicInfo.address.fullAddress,
        id: this.basicInfo.address ? this.basicInfo.address.id : '',
        province: this.selectAddress.sheng.name,
        provinceCode: this.selectAddress.sheng.code
      }
      // if (JSON.stringify(addressVo.county !== undefined) !== JSON.stringify(addressVo.fullAddress !== undefined)) {
      if (this.checkType && (!addressVo.county || !addressVo.fullAddress)) {
        this.$message.error('请完善地址信息')
        return
      }
      let auditStoreVo = {
        addressVo: addressVo,
        auditStatus: this.checkType ? 'HANDLE' : 'REFUSE',
        code: this.basicInfo.code,
        id: this.$route.query.id,
        sendFlag: this.basicInfo.sendFlag,
        storeTypeid: this.checkType ? this.basicInfo.storeTypeBean.id : ''
      }
      storeAuditStore(auditStoreVo).then(res => {
        if (res.data.success) {
          this.$message.success('审核成功')
          if (this.checkType) {
            // this.$router.go(-1)
            this.storeMsg = res.data.data
            this.storeMsg.userName = this.$msg.filterBridal(res.data.data.userName)
            this.checkTrueDialog = true
          } else {
            this.checkDialog = false
            this.$router.go(-1)
          }
        }
      })
    },
    changeAddress (val) {
      this.basicInfo.address = val
    },
    checkCode () {
      if (this.basicInfo.code === this.$route.query.code) {
        this.isRepeat = true
        this.$refs.repeatRef.innerText = ''
      } else {
        this.isRepeat = false
        this.isCheckedRepeat = false
      }
    },
    checkRepeat () {
      checkStoreCode(this.basicInfo.code).then(res => {
        if (res.data.success) {
          this.$message.success('可以使用')
        } else {
          this.$message.error('该平台号已被占用')
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";

@deep: ~">>>";
</style>
